
<div mat-dialog-title>
	<fa-icon icon="times" (click)="onCancelClick()" class="fdm-icon float-right" style="cursor:pointer;color:#555;margin-top:-20px;margin-right:-14px;"></fa-icon>
	{{data.title }}
</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
<div mat-dialog-content>
<textarea id="texteditor" style="width:100%;height:100%;min-height:600px;font-family:monospace;padding:3px 7px;border:dotted 1px #ccc !important;">{{ data.text }}</textarea>
</div>
<div mat-dialog-actions class="align-content-right">
    <button *ngIf="data.negBtn" color="primary" mat-button (click)="onCancelClick()">{{ 'GENERIC.CANCEL' | translate }}</button>
    <button color="primary" mat-button (click)="onSaveClick()" >{{ 'GENERIC.SAVE' | translate }}</button>
</div>
